import { render, staticRenderFns } from "./RentsDistribution.vue?vue&type=template&id=ccd31c22&scoped=true&"
import script from "./RentsDistribution.vue?vue&type=script&lang=js&"
export * from "./RentsDistribution.vue?vue&type=script&lang=js&"
import style0 from "./RentsDistribution.vue?vue&type=style&index=0&id=ccd31c22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd31c22",
  null
  
)

export default component.exports